import { TenantComplianceForm } from '../../../../../../backend-core-lib/app/common-shared/account/models/tenant';
import { evaluateFormlyExpression } from '../../../../common-shared/forms/utils/evaluate-formly-expression';
import { decompressAndDecodeData } from '../../../../common-shared/utils/data';
import { FilledCompliance } from '../../../../../../backend-core-lib/app/common-shared/account/models';

export function requiresComplianceFormManualApproval(
  originalComplianceForm: TenantComplianceForm,
  activeFilledCompliance: FilledCompliance,
): boolean {
  return !originalComplianceForm?.manualApprovalData
    ? false
    : evaluateFormlyExpression(
        !activeFilledCompliance.modelData
          ? {}
          : JSON.parse(
              decompressAndDecodeData(activeFilledCompliance.modelData),
            ),
        JSON.parse(
          decompressAndDecodeData(originalComplianceForm.manualApprovalData),
        ),
      );
}
